var systemRecaptcha = require('recaptcha');

var $recaptchaForm;

var recaptchaChallengeCallback = function(token) {

	console.log('challenge completed...submit the form');
	console.log(token);

	$recaptchaForm.find('input[name="recaptchaToken"]').val(token);
	$recaptchaForm.submit();
	setBtnToProcessingState($recaptchaForm.find('.submit'));

};

var dom = {},

	$ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null),

	state = {},

	scrollToElement = require('scroll-to-element'),

	setupDom = function(){

		dom.document = $(document);
		dom.loginForm = $(".login-form");
		dom.countryCode = $("#country_code");
		dom.provinces = $("#provinces");

	},

	setupInitialState = function(){

		state.isModalOpened = false;
		state.fieldToFocus = "";

	},

	addEventHandlers = function(){

		dom.document.on("click", ".submit:not(.disabled)", function(e){

			var $btn = $(this);
			var $form = $btn.closest('form');

			e.preventDefault();

			if ($form.find('input[name="recaptchaToken"]').length) {

				$recaptchaForm = $form;

				if (window.grecaptcha.getResponse()) {

					// Use the token we already have since for some reason the recaptcha library won't call our callback again in this scenario
					recaptchaChallengeCallback(window.grecaptcha.getResponse());

				} else {

					// Execute the recaptcha challenge, which will either immediately pass or present the user with a challenge to complete, in either case our callback should eventually get invoked
					window.grecaptcha.execute();

				}

			} else {

				$form.submit();

				setBtnToProcessingState($btn);

			}

		});

		dom.document.on("click", ".submit.disabled", function(e){

			e.preventDefault();

		});

		dom.document.on("click", ".home-contact-us-btn", function(e){

			e.preventDefault();

			$('.contact-wrapper').css({
				height: 'auto'
			});

			scrollToElement({
				element: '.contact-wrapper',
				force: true
			});

		});

		dom.loginForm.on("keypress", "input", function(e){

			if(e.which === 13){

				setBtnToProcessingState($(this).closest("form").find(".submit"));

				dom.loginForm.submit();

			}

		});

		dom.document.on("jqm_modal_closed", function(e){

			setBtnsToReadyState();

			e.preventDefault();

		});

		dom.document.on("form_alert_opened", function(e) {

			state.isModalOpened = true;

			if (typeof e.field === "undefined") {

				// If the error isn't related to a specific field, reset recaptcha so we can force a fresh token (avoids "timeout-or-duplicate" recaptcha error if the error happens after our token validation)
				window.grecaptcha.reset();

			} else {

				state.fieldToFocus = e.field;

			}

		});

		dom.document.on("submitted_expired_password_reset_form", function(e){

			state.isModalOpened = true;

			dom.document.on("jqm_modal_closed", function(){
				top.window.location = '/forgot-password';
			});

		});

		dom.document.on("updated_password", function(e){

			state.isModalOpened = true;

			dom.document.on("jqm_modal_closed", function(){
				top.window.location = '/login';
			});

		});

		dom.document.on("jqm_modal_closed", function(){

			if(state.isModalOpened) {

				if(state.fieldToFocus.length){

					dom.document.find("[name='" + state.fieldToFocus + "']").focus();

				}

				state.isCheckoutModalOpened = false;

			}

		});

		dom.countryCode.on("change", function(){

			// update the provinces (there is a helper in the web root for this)
			$.ajax({

				url: "/provinces_json.cfm",
				type: "POST",
				data: {
					country_code: $(this).val()
				},
				success: function(){

					var provinceHtml = "",
						provinces = arguments[0].provinces,
						i;

					for(i = 0; i < provinces.length; i++){

						provinceHtml = provinceHtml + "<option value='" + provinces[i].code + "'>" + provinces[i].name + "</option>";

					}

					dom.provinces.html(provinceHtml);

				}

			});

		});

	},

	setBtnToProcessingState = function($btn){

		$btn.addClass("disabled");

		$btn.find(".label").text("processing...");

	},

	setBtnsToReadyState = function(){

		$(".submit.disabled")
			.removeClass("disabled")
			.find(".label")
			.text("submit");

	},

	init = function(){

		setupDom();

		setupInitialState();

		addEventHandlers();

		// Load the recaptcha library and render the invisible widget
		systemRecaptcha.init()
			.then(function() {

				window.grecaptcha.render(document.querySelector('.g-recaptcha'), {
					callback: recaptchaChallengeCallback
				}, true);

			});

	};

init();
